<div *ngIf="activity" class="last-activity">
  <div class="last-activity__text" aria-label="action" (click)="showEmail(activity)">
    <b>{{ activity.type | activityDescription : activity }}:</b>
    <span>
      {{ activity.createdDate | date : 'd.MM.yy, H:mm' }}
      {{ activity | activityInformation }}
    </span>
  </div>
  <mat-icon
    *ngIf="activity.stateTo && activity.information"
    [color]="activity.stateTo && activity.information ? 'warn' : 'primary'"
    [matTooltipPosition]="'above'"
    matTooltip="{{ activity.information | removeHtmlTags }}">
    info
  </mat-icon>
</div>
